module.exports = __webpack_public_path__ + "static/img/fanyu1.52eaa42a.png";